var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.23732 12.7778C6.90289 13.0861 6.37538 13.0718 6.0591 12.7458L0 6.5L6.0591 0.254224C6.37538 -0.0718028 6.90289 -0.08615 7.23733 0.222178C7.57176 0.530506 7.58648 1.04475 7.2702 1.37078L3.0825 5.6875L19.1665 5.6875C19.6268 5.6875 20 6.05127 20 6.5C20 6.94873 19.6268 7.3125 19.1665 7.3125L3.0825 7.3125L7.2702 11.6292C7.58648 11.9552 7.57176 12.4695 7.23732 12.7778Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.054cfa189700297ac5facc82656e4928.svg";
export { ForwardRef as ReactComponent };